import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import $ from 'jquery'
import Loading from '../components/partials/Loading';
import Header from '../components/partials/Navbar'
import Footer from '../components/partials/Footer'
import Hero from '../components/Home/Hero'
import About from '../components/Home/About'
import Framework from '../components/Home/Framework'
import Skills from '../components/Home/Skills'
import Galery from '../components/Home/Galery'
import Quotes from '../components/Home/Quotes'
import Contact from '../components/Home/Contact'

const Home = (props) => {
  const [loading, setLoading] = useState(true)
  $(function() {
    setLoading(false)
  })
  const navigate = useNavigate()
  const location = useLocation()
  $(window).on('keyup', (e) => {
    if ( e.key === 'Escape' ) {
      if ( location.pathname === '/' ) {
        navigate('/id')
      } else {
        navigate('/')
      }
    }
  })
  return (
    <div>
      {
        loading ? (
          <div className='overflow-hidden'>
            <Loading />
          </div>
        ) : (
          <div className='selection:bg-teal-400 selection:text-light sm:w-full'>
            <Header countryCode={props.countryCode}/>
            <Hero countryCode={props.countryCode}/>
            <About countryCode={props.countryCode}/>
            <Framework countryCode={props.countryCode}/>
            <Skills countryCode={props.countryCode}/>
            {/* <Galery/> */}
            <Quotes countryCode={props.countryCode}/>
            <Contact countryCode={props.countryCode}/>
            <Footer countryCode={props.countryCode}/>
          </div>
        )
      }
    </div>
  )
}

export default Home